import {put, call, select} from 'redux-saga/effects';
import {PatientActions} from '../../reducers/patient/index';
import Api from '../../services/ApiCaller';
import {delay} from 'redux-saga'

export function * requestPatient (api, {pageNumber, timeSlot, patientFilter, startDate}) {
  let {user: {all: {pageSize = 4} = {}} = {}} = yield select()

  yield call(Api.callServer, api.getAllPatients, {
    pageNumber,
    pageSize,
    startDate,
    patientFilter,
    timeSlot
  }, function * (report) {
    yield put(PatientActions.getAllPatientsRequestSuccess(report, pageNumber, pageSize));
  }, function * (error) {
    yield put(PatientActions.getAllPatientsRequestError(error))
  })
}

export function * requestSpecificPatientDocument (api, {patient}) {
  yield call(Api.callServer, api.getPatientDocument, {
    id: patient.id,
    dbq: patient.dbq,
    dbqId: patient.dbqId
  }, function * (report) {
    yield put(PatientActions.getSpecificPatientDocumentSuccess(report));
  }, function * (error) {
    yield put(PatientActions.getSpecificPatientDocumentError(error))
  })
}

export function* requestGetAllPatientInfo(api, {pageNumber, timeSlot, status, patientType, selectedCampaign}) {
  let {patient: {all: {pageSize = 10} = {}} = {}} = yield select();
  timeSlot = timeSlot && timeSlot.trim().length ? timeSlot : undefined

  if (timeSlot)
    yield call(delay, 500)

  yield call(Api.callServer, api.getAllPatientInfo, {
    pageNumber,
    pageSize,
    timeSlot,
    status, 
    patientType,
    selectedCampaign
  }, function* (patients) {
    if (patients) {
      yield put(PatientActions.getAllPatientInfoSuccess(patients, pageNumber, pageSize));
    }
  }, function* (error) {
    yield put(PatientActions.getAllPatientInfoError(error));
  }, false);
}

export function* requestSpecificPatient(api, {id}) {
  yield call(Api.callServer, api.getPatient, {id}, function* (patient) {
    yield put(PatientActions.getSpecificPatientSuccess(patient))
  }, function* (error) {
    yield put(PatientActions.getSpecificPatientError(error));
  }, false);
}

export function* requestUpdateSpecificPatient(api, {patient}) {
  yield call(Api.callServer, api.updateSpecificPatientInfo, patient, function* (updatedPatient) {
    if (updatedPatient) {
      yield put(PatientActions.updateSpecificPatientSuccess(updatedPatient));
    }
  }, function* (error) {
    yield put(PatientActions.updateSpecificPatientError(error));
  }, false);
}

export function* requestUpdateSpecificPatientSign(api, {patient}) {
  yield call(Api.callServer, api.updateSpecificPatientSignInfo, patient, function* (updatedPatient) {
    if (updatedPatient) {
      yield put(PatientActions.updateSpecificPatientSignSuccess(updatedPatient));
    }
  }, function* (error) {
    yield put(PatientActions.updateSpecificPatientSignError(error));
  }, false);
}

export function* requestCreatePatient(api, {patient}) {
  yield call(Api.callServer, api.createPatient, patient, function* (newPatient) {
    if(newPatient){
      yield put(PatientActions.createSpecificPatientSuccess(newPatient));
    }
  }, function* (error) {
    yield put(PatientActions.createSpecificPatientError(error));
  }, false);
}

export function* requestClearAllPatients(api, {selectedCampaign}) {
  yield call(Api.callServer, api.clearAllPatients, {
    selectedCampaign
  }, function* (success) {
    if (success) {
      yield put(PatientActions.clearAllPatientsRequestSuccess(success));
    }
  }, function* (error) {
    yield put(PatientActions.clearAllPatientsRequestError(error));
  }, false);
}

